export default function generateUniqueId() {
    const timestamp = Date.now(); // Get current timestamp in milliseconds
    const randomPart = Math.random().toString(36).substr(2, 9); // Generate a random string
    const uniqueId = (timestamp ^ randomPart.length).toString(36) + randomPart;
    return uniqueId;
}
